module.exports = __webpack_public_path__ + "static/media/29BDOS13.0cd29d70.jpg";